import { regular, solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Space } from "antd";
import { useTranslation } from "react-i18next";
import { internshipStatus } from "../../utils/utilFunctions";
import styles from "./ResearchOffers.module.scss";

const MentorshipActions = (props: { item: any }) => {
	const { t } = useTranslation();

	const IconText = ({
		icon,
		text,
		tooltipText,
	}: {
		icon: any;
		text: string;
		tooltipText: string;
	}) => (
		<Space title={tooltipText}>
			{icon}
			{text}
		</Space>
	);
	return (
		<>
			{props.item && (
				<div className="flex flex-wrap items-center w-full gap-2">
					{props.item !== 0 && (
						<IconText
							icon={<FontAwesomeIcon icon={solid("users")} />}
							text={
								props.item.availablePositions?.toString()
									? props.item.availablePositions?.toString() === "1"
										? props.item.availablePositions.toString() +
										  " " +
										  t("internships.seat")
										: props.item.availablePositions.toString() +
										  " " +
										  t("internships.seats")
									: "N/A"
							}
							tooltipText={t("internships.freePosts")}
							key="list-TeamOutlined"
						/>
					)}

					<IconText
						icon={
							internshipStatus(
								props.item.availableFrom,
								props.item.availableTo
							) ? (
								<FontAwesomeIcon icon={solid("circle-check")} />
							) : (
								<FontAwesomeIcon icon={solid("circle-xmark")} />
							)
						}
						text={
							internshipStatus(props.item.availableFrom, props.item.availableTo)
								? t("internships.activeInternship")
								: t("internships.closedInternship")
						}
						tooltipText={t("internships.status")}
						key="list-CircleOutlined"
					/>

					<IconText
						icon={<FontAwesomeIcon icon={regular("eye")} />}
						text={
							props.item.viewCount?.toString()
								? props.item.viewCount?.toString() === "1"
									? props.item.viewCount.toString() +
									  " " +
									  t("internships.view")
									: props.item.viewCount.toString() +
									  " " +
									  t("internships.views")
								: "N/A"
						}
						tooltipText={t("internships.views")}
						key="list-ViewOutlined"
					/>

					{Array.isArray(props.item.faculties) &&
						props.item.faculties.length > 0 &&
						props.item.faculties.map((faculty: any) => (
							<IconText
								icon={<FontAwesomeIcon icon={solid("university")} />}
								text={faculty.facultyNameRo}
								tooltipText={faculty.facultyNameRo}
								key={`faculty-${faculty.id}`}
							/>
						))}
				</div>
			)}
		</>
	);
};

export default MentorshipActions;
